import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-task-scheduler-list',
  templateUrl: './task-scheduler-list.component.html',
  styleUrls: ['./task-scheduler-list.component.scss']
})
export class TaskSchedulerListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
